/** Live dashboard tab ids. Values match URL `tab` query params. */
export enum DashboardTab {
  Overview = 'overview',
  Huddle = 'huddle',
  Operations = 'operations',
  Finance = 'finance',
  Performance = 'performance',
}

/** Period range tab values. Values match `RangeKey` and the URL `range` param. */
export enum DashboardRange {
  OneDay = '1D',
  OneWeek = '1W',
  OneMonth = '1M',
  OneYear = '1Y',
  YearToDate = 'YTD',
}

/** Huddle day tab values. Values match the URL `day` query param. */
export enum HuddleDay {
  Yesterday = 'yesterday',
  Today = 'today',
  Tomorrow = 'tomorrow',
}

/**
 * Live dashboard section titles. Values are the hide/show keys stored in
 * `hiddenSections`. Casing variants are distinct keys and must stay distinct.
 */
export enum DashboardSection {
  Appointments = 'Appointments',
  TodaysSchedule = "Today's schedule",
  Calendar = 'Calendar',
  PatientFlowTracker = 'Patient Flow Tracker',
  IncompleteTreatmentPlan = 'Incomplete treatment plan',
  OpenTreatmentPatients = 'Open treatment patients',
  UtilizationMetrics = 'Utilization metrics',
  Procedures = 'Procedures',
  ProviderUtilization = 'Provider utilization',
  ArAging = 'AR Aging',
  Tasks = 'Tasks',
  Alerts = 'Alerts',
  Production = 'Production',
  Recall = 'Recall',
  TodaysProgress = "Today's progress",
  Collection = 'Collection',
  Recare = 'Recare',
  Diagnosis = 'Diagnosis',
  TreatmentAcceptance = 'Treatment acceptance',
  ChairTime = 'Chair time',
  PatientAcceptance = 'Patient acceptance',
  CaseAcceptance = 'Case acceptance',
  NoShowRate = 'No-show rate',
  SameDayCancellation = 'Same-day cancellation',
  AppointmentOverrun = 'Appointment overrun',
  RevenuePerVisit = 'Revenue per visit',
  CaseAcceptanceRate = 'Case acceptance rate',
  AvgProviderUtilization = 'Avg. provider utilization',
  TreatmentOpportunities = 'Treatment opportunities',
  ProductionTodays = 'Production (Todays)',
  TodaysForecast = "Today's forecast",
  Patients = 'Patients',
  ProviderPerformanceBreakdown = 'Provider performance breakdown',
  YesterdaysPerformance = "Yesterday's Performance",
  Leaderboard = 'Leaderboard',
  Events = 'Events',
  OverdueActions = 'Overdue actions',
  YesterdaysActuals = "Yesterday's actuals",
  ScheduleAdjustments = 'Schedule & adjustments',
  PerformanceVsGoal = 'Performance vs goal',
  FollowUpsFromYesterday = 'Follow-ups from yesterday',
  ProviderActualsYesterday = 'Provider actuals (yesterday)',
  TomorrowsForecast = "Tomorrow's forecast",
  ScheduleAtAGlance = 'Schedule at a glance',
  PreparationForTomorrow = 'Preparation for tomorrow',
  GoalsForTomorrow = 'Goals for tomorrow',
  RevenueOverview = 'Revenue overview',
  ScheduleOperations = 'Schedule operations',
  InsuranceClaims = 'Insurance claims',
  NetHygieneProduction = 'Net hygiene production',
  ProductionPerHygieneVisit = 'Production per hygiene visit',
  ArOver90Day = 'AR over 90-day',
  PatientsAge = 'Patients age',
  PatientStatus = 'Patient status',
  ExpensesBreakdown = 'Expenses breakdown',
  SeatUtilization = 'Seat utilization',
  PracticeRevenueOverview = 'Practice revenue overview',
  CollectionPerformance = 'Collection performance',
  InsuranceVsPatientCollection = 'Insurance vs patient collection',
  DentistVsHygienistProduction = 'Dentist vs Hygienist production',
  TreatmentValue = 'Treatment value',
  OutstandingBalance = 'Outstanding balance',
  Claims = 'Claims',
  CollectionRatio = 'Collection ratio',
  ProductionByDepartment = 'Production by department',
  NetHygieneProductionFinance = 'Net Hygiene production',
  ProductionPerHygieneVisitFinance = 'Production per Hygiene visit',
  CollectionMetric = 'Collection metric',
  CollectionRate = 'Collection rate',
  ArAgingMetric = 'AR aging',
  ProductionByProcedure = 'Production by procedure',
  ProductionPerProvider = 'Production per provider',
  SchedulingPerformance = 'Scheduling performance',
  DsoDaysToCollect = 'DSO (days to collect)',
}
